import { BodyLarge400, BodyMedium400, BodyMedium500, TitleSmall500 } from '@nebula/global-styles';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    width: 802px;
    margin: 0 auto;
  }
`;

export const InfoContainer = styled.div`
  padding: 24px 16px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    padding: 24px;
  }
`;

export const CancelContainer = styled.div`
  @media (max-width: 767px) {
    padding-top: 24px;
    border-top: 8px solid ${({ theme }) => theme.color.ui.grey[10]};
  }
  padding: 24px 16px 32px 16px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    padding: 0 24px 24px 24px;
  }

  display: flex;
  flex-direction: column;
`;

export const VisuallyHidden = styled.p`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
`;

export const StyledTitleLarge500 = styled.h1`
  color: ${({ theme }) => theme.color.ui.grey[100]};
  font-size: 24px;
  font-weight: 500;
  margin: 16px 0 0 0;
  line-height: 36px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    font-size: 28px;
    line-height: 40px;
  }
`;

export const StyledTitleMedium500 = styled.h2`
  color: ${({ theme }) => theme.color.ui.grey[100]};
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    margin-top: 8px;
  }
`;

export const StyledBodyLarge400 = styled(BodyLarge400)`
  color: ${({ theme }) => theme.color.ui.grey[90]};
  margin-top: 8px;
  line-height: 24px;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    margin-top: 16px;
  }
`;

export const StyledBodyMedium500 = styled(BodyMedium500)`
  color: ${({ theme }) => theme.color.ui.grey[100]};
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    text-align: left;
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 1rem;
    line-height: 24px;
  }
`;

export const BenefitsList = styled.ul`
  list-style: disc;
  margin: 1rem 0;
  padding-left: 1.5rem;

  li {
    color: ${({ theme }) => theme.color.ui.grey[90]};
    margin-bottom: 0.5rem;
    line-height: 1.5;
  }
`;

export const AlertContainer = styled.div`
  > div > div > div {
    display: flex;
    flex-direction: column;

    p {
      font-size: 14px !important;
      @media ${({ theme }) => theme.media.tabletPortraitMin} {
        width: max-content;
      }
    }
  }
`;

export const ButtonGroup = styled.div`
  order: 2;
  margin-top: 16px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    margin-bottom: 16px;
    flex-direction: row;
    gap: 16px;
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    margin-top: 24px;
  }
`;

export const CancelButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.color.ui.grey[30]};
  border-radius: 12px;
  cursor: pointer;
  flex: 1;
  transition: all 0.2s ease;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const RadioLabel = styled.label`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const RadioTitle = styled(TitleSmall500)``;

export const RadioDescription = styled(BodyMedium400)``;

export const RetainSubscription = styled.button`
  color: ${({ theme }) => theme.color.ui.blue[70]};
  cursor: pointer;
`;

export const BenefitsSpan = styled.a`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.ui.blue[70]};
  font-weight: 500;
  font-size: 14px;
  gap: 6px;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
  }
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    font-size: 16px;
  }
`;

export const StyledBodyMedium400 = styled(BodyMedium400)`
  margin-top: 4px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    margin-top: 8px;
  }
`;

export const InfoAlertContainer = styled.div`
  order: 1;
  margin-top: 16px;

  > div > div > div > div > p {
    font-size: 16px !important;
    line-height: 24px;
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    > div > div {
      padding: 16px 16px 16px 24px;
    }
  }
`;

export const RetainSubscriptionContainer = styled.div`
  order: 3;
`;

export const IconContainer = styled.div`
  border-radius: 8px;
  flex-shrink: 0;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  flex: 1;
`;

export const TimeLabel = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.ui.grey[100]};
  line-height: 24px;
  margin: 0;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 18px;
    line-height: 28px;
  }
`;

export const EndDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.ui.grey[70]};
  line-height: 20px;
  margin: 0;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 16px;
    line-height: 24px;
  }
`;
